








































import { Component, Prop, Vue } from "vue-property-decorator";
import AccountIcon from "vue-material-design-icons/Account.vue";
import LogoutIcon from "vue-material-design-icons/LocationExit.vue";
import ResetSessionIcon from "vue-material-design-icons/DeleteForever.vue";
import LanguageDropdown from "@/components/LanguageDropdown.vue";

@Component({
  components: {
    LanguageDropdown,
    AccountIcon,
    LogoutIcon,
    ResetSessionIcon
  }
})
export default class NavBar extends Vue {
  @Prop() languageSwitchDisabled!: boolean;
  @Prop({ default: false }) showLanguageSwitch!: boolean;

  private editor = "";
  private show = false;

  openDropdown() {
    this.show = !this.show;
  }

  logout() {
    // localStorage.clear();
    this.$router.push({ name: "login" });
    this.$toast.success("Logged out");
  }

  resetSession() {
    localStorage.clear();
    this.$router.go(0);
  }

  fetchUser() {
    const editor = localStorage.getItem("editor") || "";
    this.editor = editor;
  }

  mounted() {
    this.fetchUser();
  }
}
